import { useIsOptimizelyFeatureEnabled } from 'containers/OptimizelyRollouts'
import { useAuth } from 'routes/Menu/domains/auth'

// This experiment shoud run only for non-authenticated users
export const useIsCheckoutBoxDiscountVisualisationEnabled = () => {
  const isCheckoutBoxDiscountVisualisationExperimentEnabled =
    useIsOptimizelyFeatureEnabled('beetroots_checkout_box_discount_visualisation_web_enabled') ??
    false
  const { isAuthenticated } = useAuth()

  return isCheckoutBoxDiscountVisualisationExperimentEnabled && !isAuthenticated
}
